<template>
<!-- ============================================================== -->
<!-- Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->
  <div class="row page-titles">
    <div class="col-md-6 col-8 align-self-center">
      <!-- <h3 class="text-themecolor m-b-0 m-t-0">{{title}}</h3> -->
      <ol class="breadcrumb">
        <li v-if="titles.length" v-for="title of titles" :key="title.name" class="breadcrumb-item">
          <router-link :to="{ name: title.name }">{{title.text}}</router-link>
        </li>
        <li v-if="current" class="breadcrumb-item">
          {{current}}
        </li>
      </ol>
    </div>
    <!-- <div class="col-md-6 col-4 align-self-center">
      <button class="right-side-toggle waves-effect waves-light btn-info btn-circle btn-sm pull-right m-l-10"><i class="ti-settings text-white"></i></button>
      <button class="btn pull-right hidden-sm-down btn-success"><i class="mdi mdi-plus-circle"></i> Create</button>
      <div class="dropdown pull-right m-r-10 hidden-sm-down">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          January 2017
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" href="#">February 2017</a>
          <a class="dropdown-item" href="#">March 2017</a>
          <a class="dropdown-item" href="#">April 2017</a>
        </div>
      </div>
    </div> -->
  </div>
<!-- ============================================================== -->
<!-- End Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->
</template>

<script>
export default {
  name: 'breadcrumbs',
  props: {
    current: String,
  },
  computed: {
    titles() {
      return this.$store.state.route.meta.breadcrumbs || [];
    },
    isNotRoot() {
      return this.$store.state.route.path !== '/';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue